import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface MenuState {
  selectedItem: string;
  drawerOpen: boolean;
}

const initialState: MenuState = {
  selectedItem: '',
  drawerOpen: false
};

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action: PayloadAction<string>) {
      state.selectedItem = action.payload;
    },
    openDrawer(state, action: PayloadAction<boolean>) {
      state.drawerOpen = action.payload;
    }
  }
});

export default menu.reducer;

export const { activeItem, openDrawer } = menu.actions;
